import _ from 'lodash';

/**
 * @param {import('./config').MemberDeepLinks} memberDeepLinks
 * @param {string} dataSource e.g. `onelife`
 * @returns {boolean}
 */
export function isDataSourceMemberBookable(memberDeepLinks, dataSource) {
  if (_.isEmpty(memberDeepLinks)) return false;
  if (_.isNil(memberDeepLinks[dataSource])) return false;
  return true;
}

/**
 * @param {object} args
 * @param {boolean} args.isFull
 * @param {boolean} args.isAvailableToBook
 * @param {boolean} args.isThisDataSourceMemberBookable
 * @param {import('../../sessions-timetable/Config').GuestButtonCustomTextConfig} [args.guestButtonCustomText]
 * @returns {string}
 */
export function getGuestBookButtonText({
  isFull,
  isAvailableToBook,
  isThisDataSourceMemberBookable,
  guestButtonCustomText,
}) {
  if (isFull) return guestButtonCustomText?.ifFull ?? 'Guest Booking Unavailable';
  if (isAvailableToBook)
    return guestButtonCustomText?.ifBookableAndAvailable ?? 'Pay & Play Booking';
  // Session is not full and not bookable by guests at this point

  // If isThisDataSourceMemberBookable is true, then it means that members can also book, and
  // therefore member and non-member booking must be differentiated.
  // Note that this logic only pertains to the default text. If custom text is provided, it
  // is assumed that the client  will choose something that is sufficient for their situation
  // and may find the distinction confusing.
  if (isThisDataSourceMemberBookable)
    return guestButtonCustomText?.ifNotBookable ?? 'Contact Centre for P&P';
  return guestButtonCustomText?.ifNotBookable ?? 'Contact Centre';
}
